import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-direction-arrow',
  templateUrl: './direction-arrow.component.html',
  styleUrls: ['./direction-arrow.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirectionArrowComponent {
  @Input() direction = '';
}
